import { parseFilters } from '../../../libs/filter.lib'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  TagSearchField,
  TagSearchParams,
  TagSortField,
} from '../models/tag-search.model'
import { TagTarget } from '../models/tag.types'

export const TAG_TARGETS: { code: TagTarget; name: string }[] = [
  {
    code: 'products',
    name: 'Prodotti',
  },
  {
    code: 'orders',
    name: 'Ordini clienti',
  },
]

export function parseTagFilters(
  params: TagSearchParams,
  filters: TagSearchParams,
): TagSearchParams {
  return parseFilters(params, filters, tagFilterParams)
}

export function tagSortParams(
  params: TagSearchParams,
  sort: QueryStringSort<TagSortField>,
): TagSearchParams {
  const searchParams: TagSearchParams = {}

  switch (sort.field) {
    case 'value':
      searchParams.sort = 'value'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

export function tagFilterParams(
  params: TagSearchParams,
  filter: QueryStringFilter<TagSearchField>,
): TagSearchParams {
  const searchParams: TagSearchParams = {}

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'value':
      if (filter.operator === '=') {
        searchParams.value = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['value:ct'] = filter.value
      }
      break
    case 'target':
      if (filter.value !== null) {
        searchParams.target = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
